import { messagingActions } from '../reducers/messagingSlice';
import { useAppDispatch } from '../app/hooks';
import { setLanguage } from '../reducers/languageSlice';
import { Languages } from '../utils/constants';

const useLanguages = function () {
  const dispatch = useAppDispatch();
  const sendLanguageSwitch = (newLanguage: Languages) => {
    const payload = {
      data: {
        new_language: newLanguage,
      },
    };
    dispatch(messagingActions.sendInfo(payload as any));
    dispatch(setLanguage(newLanguage));
  };
  return { sendLanguageSwitch };
};

export default useLanguages;
